import axiosInstance from "../../apiAxios/axiosInstance";

export const ColorList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/color-list",payload);
   return resposne.data
};
export const ActiveColorList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-color-list",payload);
   return resposne.data
};

export const AddColor = (payload) => {
  return axiosInstance.post("/admin/color-store", payload);
};

export const ViewColor = (payload) => {
  return axiosInstance.post("/admin/color-show", payload);
};

export const UpdateColor = (payload) => {
  return axiosInstance.post("/admin/color-update", payload);
};

// Delete
export const DeleteColor = async(payload) => {
 const response= await axiosInstance.post("/admin/color-delete", payload);
 return response.data
};
export const getColorByCategory = async(payload) => {
 const response= await axiosInstance.post("/admin/get-colors-by-category", payload);
 return response.data
};

export const ColorChangeStatus = (payload) => {
  return axiosInstance.post("/admin/color-status-update", payload);
};